import { c as _c } from "react/compiler-runtime";
import { CheckCircleIcon } from "@heroicons/react/24/solid";
interface ApprovalStatusBadgeProps {
  readonly approvedAt?: number | null | undefined;
  readonly size?: "sm" | "md" | undefined;
}
export default function ApprovalStatusBadge(t0) {
  const $ = _c(7);
  const {
    approvedAt: t1,
    size: t2
  } = t0;
  const approvedAt = t1 === undefined ? null : t1;
  const size = t2 === undefined ? "sm" : t2;
  let t3;
  if ($[0] !== approvedAt) {
    t3 = typeof approvedAt === "number" && Number.isFinite(approvedAt) ? `${"Approved"} on ${new Date(approvedAt).toISOString()}` : "Approved";
    $[0] = approvedAt;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const title = t3;
  const sizeClasses = size === "md" ? "tw-gap-1.5 tw-px-2.5 tw-py-1 tw-text-xs" : "tw-gap-1 tw-px-2 tw-py-0.5 tw-text-[11px]";
  const t4 = `tw-inline-flex tw-flex-shrink-0 tw-items-center tw-rounded-full tw-border tw-border-solid tw-border-emerald-400/25 tw-bg-emerald-400/10 tw-font-semibold tw-leading-none tw-text-emerald-300 ${sizeClasses}`;
  let t5;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <CheckCircleIcon className="tw-size-3.5 tw-flex-shrink-0" />;
    t6 = <span>{"Approved"}</span>;
    $[2] = t5;
    $[3] = t6;
  } else {
    t5 = $[2];
    t6 = $[3];
  }
  let t7;
  if ($[4] !== t4 || $[5] !== title) {
    t7 = <span title={title} className={t4}>{t5}{t6}</span>;
    $[4] = t4;
    $[5] = title;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  return t7;
}